module.exports = __webpack_public_path__ + "static/media/31-9.210a226c.mp3";